(function(){
  var arranging = false;
  function wrap(selector, title, subtitle){
    var el = document.querySelector(selector);
    if(!el || el.closest('.kt-accordion')) return;
    var details = document.createElement('details');
    details.className = 'kt-accordion';
    var summary = document.createElement('summary');
    summary.className = 'kt-accordion__summary';
    summary.innerHTML = '<span class="kt-accordion__title">'+title+'</span><span class="kt-accordion__subtitle">'+(subtitle||'')+'</span><span class="kt-accordion__hint">More info <span class="kt-caret"></span></span>';
    var body = document.createElement('div');
    body.className = 'kt-accordion__body';
    el.parentNode.insertBefore(details, el);
    details.appendChild(summary);
    details.appendChild(body);
    body.appendChild(el);
  }

  function unwrapIfWrapped(selector){
    var el = document.querySelector(selector);
    if(!el) return;
    var acc = el.closest('details.kt-accordion');
    if(acc && acc.parentNode){
      acc.parentNode.insertBefore(el, acc);
      acc.remove();
    }
  }

  function findLoyaltyNode(){
    var candidates = [
      '.loyalty-widget',
      '.t4s-loyalty-widget',
      '[data-loyalty-widget]',
      '.kt-loyalty',
      '.loyaltylion',
      '[id*="loyalty" i]',
      '[class*="loyalty" i]'
    ];
    for(var i=0;i<candidates.length;i++){
      var el = document.querySelector(candidates[i]);
      if(el) return el;
    }
    // last resort: search by heading text
    var headings = Array.prototype.slice.call(document.querySelectorAll('h1,h2,h3,h4,div,section'));
    for(var j=0;j<headings.length;j++){
      var node = headings[j];
      if(node.textContent && /Loyalty Rewards/i.test(node.textContent)){
        return node.closest('section, div, article') || node;
      }
    }
    return null;
  }

  function arrangeBulkAndForm(){
    if(arranging) return; arranging = true;
    var bulk = document.querySelector('.bulk-pricing-container.kt-card, .t4s-product__bulk-pricing .bulk-pricing-container');
    var form = document.querySelector('form[action*="/cart/add"]');
    if(!(bulk && form)) { arranging = false; return; }
    var row = bulk.closest('.kt-buy-row') || form.closest('.kt-buy-row');
    if(!row){
      row = document.createElement('div');
      row.className = 'kt-buy-row';
      var left = document.createElement('div');
      left.className = 'kt-left';
      var right = document.createElement('div');
      right.className = 'kt-right';
      var parent = form.parentNode;
      parent.insertBefore(row, form);
      row.appendChild(left);
      row.appendChild(right);
      // Earlier correct layout: Bulk Pricing on left, Add-to-Cart on right
      left.appendChild(bulk);
      right.appendChild(form);
    } else {
      // Ensure wrappers exist and correct placement
      var leftCol = row.querySelector('.kt-left');
      var rightCol = row.querySelector('.kt-right');
      if(!leftCol){ leftCol = document.createElement('div'); leftCol.className='kt-left'; row.insertBefore(leftCol, row.firstChild); }
      if(!rightCol){ rightCol = document.createElement('div'); rightCol.className='kt-right'; row.appendChild(rightCol); }
      if(bulk.parentNode !== leftCol){ leftCol.appendChild(bulk); }
      if(form.parentNode !== rightCol){ rightCol.appendChild(form); }
    }

    // Ensure loyalty sits below bulk inside the left column as a regular div
    var leftCol = row.querySelector('.kt-left');
    var loyalty = findLoyaltyNode();
    if(loyalty){
      // If not wrapped yet, wrap in a simple div container
      if(!loyalty.closest('.kt-loyalty-container')){
        var container = document.createElement('div');
        container.className = 'kt-loyalty-container kt-loyalty-left';
        
        loyalty.parentNode.insertBefore(container, loyalty);
        container.appendChild(loyalty);
        loyalty = container;
      }
      var loyaltyContainer = loyalty.closest('.kt-loyalty-container');
      // Place loyalty below the row at full width
      if(loyaltyContainer){
        // Prefer placing inside the media wrapper section (left column)
        var mediaWrapper = document.querySelector('.t4s-product__media-wrapper');
        if(mediaWrapper){
          loyaltyContainer.classList.remove('kt-loyalty-full');
          loyaltyContainer.classList.add('kt-loyalty-left');
          // Append at end of media wrapper so it sits below gallery + thumbs
          if(loyaltyContainer.parentNode !== mediaWrapper){
            mediaWrapper.appendChild(loyaltyContainer);
          }
        } else {
          // Fallback: place loyalty below the product section (after buy row)
          loyaltyContainer.classList.remove('kt-loyalty-left');
          loyaltyContainer.classList.add('kt-loyalty-full');
          if(row.nextSibling !== loyaltyContainer){
            row.parentNode.insertBefore(loyaltyContainer, row.nextSibling);
          }
        }
        // Keep the header and description - they contain the title and subtitle
        // Wrap visible content inside a centered container for compact width
        var body = loyaltyContainer;
        if(body && !body.querySelector('.kt-loyalty-inner')){
          var inner = document.createElement('div');
          inner.className = 'kt-loyalty-inner';
          // move all child nodes into inner
          while(body.firstChild){ inner.appendChild(body.firstChild); }
          body.appendChild(inner);
        }
      }
    }
    arranging = false;
  }

  function init(){
    // Do not wrap bulk pricing or back-in-stock
    unwrapIfWrapped('.t4s-product__back-in-stock, [data-back-in-stock], .kt-back-in-stock');
    wrap('.loyalty-widget, .t4s-loyalty-widget, [data-loyalty-widget]', 'Loyalty Rewards', 'Earn points and redeem discounts');
    arrangeBulkAndForm();
  }

  function setupObserver(){
    var scheduled = false;
    var obs = new MutationObserver(function(){
      if(scheduled) return;
      scheduled = true;
      requestAnimationFrame(function(){
        scheduled = false;
        arrangeBulkAndForm();
      });
    });
    obs.observe(document.body, {childList:true, subtree:true});
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', function(){ init(); setupObserver(); });
  } else {
    init(); setupObserver();
  }
})();

